import {AvailableVehicleCategory} from '../../features/entities/category/enum/available-vehicle-category.enum';

export function isVehicleRegisterableResolver(availableVehicleCategory: AvailableVehicleCategory): boolean {
  switch (availableVehicleCategory) {
    case AvailableVehicleCategory.CAR:
      return true;
    case AvailableVehicleCategory.TRUCK:
      return true;
    case AvailableVehicleCategory.TRAILERS:
      return true;
    case AvailableVehicleCategory.BUS:
      return true;
    case AvailableVehicleCategory.MOTORCYCLE:
      return true;
    case AvailableVehicleCategory.CONSTRUCTION_VEHICLE:
      return true;
    case AvailableVehicleCategory.AGRICULTURAL_VEHICLE:
      return true;
    default:
      return false;
  }
}
